import { doc, getDoc, setDoc } from 'firebase/firestore';
import firebase from '../firebase-config';

const { firestore } = firebase;

export const firestoreService = {
  async getSubscription(userId) {
    try {
      const docRef = doc(firestore, 'subscriptions', userId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return docSnap.data();
      }
      return null;
    } catch (error) {
      console.error('Error getting subscription:', error);
      return null;
    }
  },

  async saveSubscription(userId, subscriptionData, userEmail) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      // Add additional metadata
      const enrichedData = {
        ...subscriptionData,
        updatedAt: new Date().toISOString(),
        createdAt: new Date().toISOString(),
        userId: userId,
        userEmail: userEmail,
        status: 'active'
      };

      const subscriptionRef = doc(firestore, 'subscriptions', userId);
      await setDoc(subscriptionRef, enrichedData);
      
      console.log('Subscription saved successfully for user:', userId);
      return true;
    } catch (error) {
      console.error('Error saving subscription:', error);
      throw error;
    }
  }
}; 